<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" @click="$emit('close')" icon>
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูลสาขา
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('departmentStore') }"
          >
            <label>{{ $t('ชื่อห้าง') }}</label>
            <input
              :data-vv-as="$t('ชื่อห้าง')"
              v-validate="'required'"
              v-model="input.departmentStore"
              class="form-control"
              type="text"
              name="departmentStore"
            />
            <span class="text-error" v-if="errors.has('departmentStore')">{{
              errors.first('departmentStore')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('departmentStoreId') }"
          >
            <label>{{ $t('รหัสของห้าง') }}</label>
            <input
              :readonly="edittype == 'edit'"
              :data-vv-as="$t('รหัสสาขาของ toa')"
              v-validate="'required'"
              v-model="input.departmentStoreId"
              class="form-control"
              type="text"
              name="departmentStoreId"
            />
            <span class="text-error" v-if="errors.has('departmentStoreId')">{{
              errors.first('departmentStoreId')
            }}</span>
          </v-flex>

          <v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('branch') }">
            <label>{{ $t('ชื่อสาขา') }}</label>
            <input
              :data-vv-as="$t('ชื่อสาขา')"
              v-validate="'required'"
              v-model="input.branch"
              class="form-control"
              type="text"
              name="branch"
            />
            <span class="text-error" v-if="errors.has('branch')">{{ errors.first('branch') }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('branchId') }"
          >
            <label>{{ $t('รหัสสาขาของห้าง') }}</label>
            <input
              :readonly="edittype == 'edit'"
              :data-vv-as="$t('รหัสสาขาของห้าง')"
              v-validate="'required'"
              v-model="input.branchId"
              class="form-control"
              type="text"
              name="branchId"
            />
            <span class="text-error" v-if="errors.has('branchId')">{{
              errors.first('branchId')
            }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
          <v-btn :loading="saveloading" @click="savedata" depressed color="primary">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        branchId: '', // รหัสสาขาของห้าง
        departmentStoreId: '', // รหัสห้าง
        departmentStore: '', // ห้าง
        branch: '' // สาขา
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = {
        branchId: this.editdata.branch_id, // รหัสสาขาของห้าง
        departmentStoreId: this.editdata.department_store_id, // รหัสสาขาของห้อง
        departmentStore: this.editdata.department_store, // ห้าง
        branch: this.editdata.branch // สาขา
      }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editbranch()
        }
      }
    },
    editbranch() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.edittoacrmBranch(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    },
    createdata() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.createtoacrmBranch(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/BranchEdit.vue